import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function PersonOfConcernContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  personOfConcernId,
  getSinglePersonOfConcern,
  personOfConcernInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(personOfConcernId)) return;
    getSinglePersonOfConcern(personOfConcernId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(personOfConcernId)) return;
    getSinglePersonOfConcern(personOfConcernId);
  }, [personOfConcernId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(personOfConcernInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">
                    {_.get(personOfConcernInfo, 'attributes.first_name')}{" "}
                    {_.get(personOfConcernInfo, 'attributes.middle_name')}{" "}
                    {_.get(personOfConcernInfo, 'attributes.last_name')}{" "}
                    {_.get(personOfConcernInfo, 'attributes.suffix') || ''}
                  </h3>
                  <h5>
                    {_.get(
                      personOfConcernInfo,
                      'attributes.is_approver'
                    ) === 1
                      ? 'Approver'
                      : ''}

                    {(_.get(
                      personOfConcernInfo,
                      'attributes.is_approver'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_recommender'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_assessor'
                    ) === 0) && ', '}

                    {(_.get(
                      personOfConcernInfo,
                      'attributes.is_approver'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_recommender'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_assessor'
                    ) === 1) && ', '}

                    {(_.get(
                      personOfConcernInfo,
                      'attributes.is_approver'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_recommender'
                    ) === 0 && _.get(
                      personOfConcernInfo,
                      'attributes.is_assessor'
                    ) === 1) && ', '}

                    {_.get(
                      personOfConcernInfo,
                      'attributes.is_recommender'
                    ) === 1
                      ? 'Recommender'
                      : ''}

                    {(_.get(
                      personOfConcernInfo,
                      'attributes.is_approver'
                    ) === 0 && _.get(
                      personOfConcernInfo,
                      'attributes.is_recommender'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_assessor'
                    ) === 1) && ', '}

                    {(_.get(
                      personOfConcernInfo,
                      'attributes.is_approver'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_recommender'
                    ) === 1 && _.get(
                      personOfConcernInfo,
                      'attributes.is_assessor'
                    ) === 1) && ', '}

                    {_.get(
                      personOfConcernInfo,
                      'attributes.is_assessor'
                    ) === 1
                      ? 'Assessor'
                      : ''}
                  </h5>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(personOfConcernInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(personOfConcernInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <table className="transaction-table table table-borderless table-striped table-sm ">
                <tbody>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Name
                    </td>
                    <td>
                      {_.get(personOfConcernInfo, 'attributes.first_name')}{" "}
                      {_.get(personOfConcernInfo, 'attributes.middle_name')}{" "}
                      {_.get(personOfConcernInfo, 'attributes.last_name')}
                    </td>
                  </tr>
                  <tr>
                    <td className="span-title2 font-weight-bold" width="250">
                      Type
                    </td>
                    <td>
                      {_.get(
                        personOfConcernInfo,
                        'attributes.is_approver'
                      ) === 1
                        ? 'Approver'
                        : ''}

                      {(_.get(
                        personOfConcernInfo,
                        'attributes.is_approver'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_recommender'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_assessor'
                      ) === 0) && ', '}

                      {(_.get(
                        personOfConcernInfo,
                        'attributes.is_approver'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_recommender'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_assessor'
                      ) === 1) && ', '}

                      {(_.get(
                        personOfConcernInfo,
                        'attributes.is_approver'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_recommender'
                      ) === 0 && _.get(
                        personOfConcernInfo,
                        'attributes.is_assessor'
                      ) === 1) && ', '}

                      {_.get(
                        personOfConcernInfo,
                        'attributes.is_recommender'
                      ) === 1
                        ? 'Recommender'
                        : ''}

                      {(_.get(
                        personOfConcernInfo,
                        'attributes.is_approver'
                      ) === 0 && _.get(
                        personOfConcernInfo,
                        'attributes.is_recommender'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_assessor'
                      ) === 1) && ', '}

                      {(_.get(
                        personOfConcernInfo,
                        'attributes.is_approver'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_recommender'
                      ) === 1 && _.get(
                        personOfConcernInfo,
                        'attributes.is_assessor'
                      ) === 1) && ', '}

                      {_.get(
                        personOfConcernInfo,
                        'attributes.is_assessor'
                      ) === 1
                        ? 'Assessor'
                        : ''}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

PersonOfConcernContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  getSinglePersonOfConcern: PropTypes.instanceOf(Function).isRequired,
  personOfConcernInfo: PropTypes.instanceOf(Object).isRequired,
  personOfConcernId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  personOfConcernInfo: _.get(api, `${c.GET_SINGLE_PERSON_OF_CONCERN}.item`) || {},
  personOfConcernId: _.get(match, 'params.personOfConcernId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PersonOfConcernContent);
